// extracted by mini-css-extract-plugin
export default {"note":"Note_note__p9m7C","colored":"Note_colored__AnUDN"};